export default axios => ({
  /**
   * Возвращает информацию о текущем профиле
   *
   * @returns {*}
   */
  me () {
    return axios.get('/web/profile/me')
  },
  /**
   * Удаляет аватарку
   *
   * @returns {*}
   */
  deletePhoto () {
    return axios.delete('/web/profile/avatar')
  },
  /**
   * Загружает аватарку
   *
   * @param base64File
   * @returns {*}
   */
  uploadAvatar (base64File) {
    return axios.post('/web/profile/avatar', { base64File })
  }
})
